import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@core/guards/auth.guard';
import { SlugGuard } from '@core/guards/slug.guard';
import { ChannelPageResolver } from '@core/resolvers/channel-page.resolver';
import { environment } from '@environment';

import { NotFoundComponent } from './features/not-found/not-found.component';
import { PageBuilderSmartComponent } from './features/page/page-builder-smart.component';
import { ScopeResolver } from './scope.resolver';

const scopedRoutes: Routes = [
  {
    path: '',
    canActivate: [SlugGuard],
    children: [
      {
        path: 'videos',
        loadChildren: () =>
          import('./features/video/video.module').then((m) => m.VideoModule),
      },
      {
        path: 'events',
        loadChildren: () =>
          import('./features/page/page-routes').then((m) => m.eventRoutes),
      },
      {
        path: 'tags',
        loadChildren: () =>
          import('./features/page/page-routes').then((m) => m.tagRoutes),
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./features/page/page-routes').then(
            (m) => m.dynamicPageRoutes
          ),
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('./features/page/page-routes').then((m) => m.calendarRoute),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
      },
      {
        path: 'sport80',
        loadComponent: () => {
          return import('./features/sport80/sport80.component').then(
            (c) => c.Sport80Component
          );
        },
      },
      {
        path: 'filming-consent',
        loadComponent: () => {
          return import(
            './features/filming-consent/filming-consent.component'
          ).then((c) => c.FilmingConsentComponent);
        },
      },
      {
        path: '',
        pathMatch: 'full',
        component: PageBuilderSmartComponent,
        resolve: { pageScope: ChannelPageResolver },
      },
    ],
  },
];

/**
 * List of entrypoints.
 * Since the Angular Router checks for matches from first to last,
 * the `:slug` route must always be the last one to be added.
 * Otherwise, all routes will be considered slugs.
 * This is why it's manually pushed after the rest of routes are assigned.
 */
const rootRoutes: Routes = [
  { path: '404', canActivate: [AuthGuard], component: NotFoundComponent },
  {
    path: ':slug',
    canActivate: [AuthGuard],
    resolve: { scope: ScopeResolver },
    runGuardsAndResolvers: 'paramsChange',
    children: [...scopedRoutes, { path: '**', component: NotFoundComponent }],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home',
  },
];

@NgModule({
  imports: [
    PageBuilderSmartComponent,
    RouterModule.forRoot(rootRoutes, {
      initialNavigation: 'enabledBlocking',
      enableTracing: environment.enableRouterTracing || false, // Disable for prod
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
      scrollOffset: [0, 100],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
